export const SERVER_ERROR = 'SERVER_ERROR';
export const UNKNOWN = 'UNKNOWN';
export const VALIDATION_FAILED = 'VALIDATION_FAILED';
